(() => {
  if (!document.querySelector('#halloween-kits') || window.hw26HeaderRegionInitialized) return;
  const forms = Array.from(document.querySelectorAll('form[id^="HeaderCountry"]'))
    .filter(form => form.querySelector('[name="country_code"]'));
  const form = forms[0];
  if (!form) return;
  window.hw26HeaderRegionInitialized = true;
  const input = form.querySelector('[name="country_code"]');
  const supported = new Set(Array.from(form.querySelectorAll('[data-value]'), link => link.dataset.value));
  const choiceKey = 'temppro-country-choice';
  const checkedKey = 'hw26-region-checked';
  const read = (store, key) => { try { return window[store].getItem(key); } catch (_) { return null; } };
  const write = (store, key, value) => { try { window[store].setItem(key, value); } catch (_) {} };
  const returnTo = target => {
    const url = new URL(location.href);
    url.searchParams.delete('country');
    url.searchParams.delete('currency');
    let field = target.querySelector('[name="return_to"]');
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; target.append(field); }
    field.value = url.pathname + url.search;
  };
  const remember = country => {
    if (!supported.has(country)) return;
    write('localStorage', choiceKey, country);
    write('sessionStorage', checkedKey, '1');
  };
  let manualChange = false;
  // Preserve the native header/menu selector and its market submission.
  document.addEventListener('click', event => {
    const link = event.target.closest('localization-form [data-value]');
    const target = link?.closest('form');
    if (target?.querySelector('[name="country_code"]')) {
      manualChange = true;
      remember(link.dataset.value);
      returnTo(target);
    }
  }, true);
  forms.forEach(target => target.addEventListener('submit', () => {
    manualChange = true;
    remember(target.querySelector('[name="country_code"]').value);
    returnTo(target);
  }));
  if (window.Shopify?.designMode || read('localStorage', choiceKey) || read('sessionStorage', checkedKey)) return;
  const params = new URLSearchParams(location.search);
  if (params.has('country') || params.has('currency')) { remember(input.value); return; }
  // Preserve a market already selected by Shopify or the visitor.
  if (input.value !== 'US') return;
  write('sessionStorage', checkedKey, '1');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const base = window.Shopify?.routes?.root || '/';
  fetch(base + 'browsing_context_suggestions.json?country%5Benabled%5D=true', {
    credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
  }).then(response => response.ok ? response.json() : null).then(data => {
    if (manualChange || read('localStorage', choiceKey)) return;
    const country = data?.detected_values?.country?.handle;
    if (!supported.has(country) || country === input.value) return;
    input.value = country;
    returnTo(form);
    HTMLFormElement.prototype.submit.call(form);
  }).catch(() => {}).finally(() => clearTimeout(timeout));
})();
